import { deviceSize, useDeviceSize } from 'fitify-ui'
import type { ImageTypes } from 'fitify-ui-landing/src/@types'
import { StyledHeaderContainer } from 'fitify-ui-landing/src/components/blocks/Header/Header.Styled'
import Button from 'fitify-ui-landing/src/components/Button/Button'
import type { ButtonVariants } from 'fitify-ui-landing/src/components/Button/Button.Types'
import NativeImage from 'fitify-ui-landing/src/components/Image/NativeImage'
import { Text } from 'fitify-ui-landing/src/components/Text'
import { ThemeVariants } from 'fitify-ui-landing/src/theme/index'
import { useTranslation } from 'next-i18next'
import { useTheme } from 'styled-components'

import {
  StyledBusinessHeaderWrapper,
  StyledBusinessHeaderWrapperContent,
  StyledHeader,
  StyledImageContainer,
  StyledMobileImage,
} from './BusinessHeader.Styled'

interface HeaderProps {
  headerImage: ImageTypes.Header
  headline: string
  subheadline: string
  buttonCta: string
  buttonVariant: ButtonVariants
}

const BusinessHeader = ({
  headerImage,
  headline,
  subheadline,
  buttonCta,
  buttonVariant,
}: HeaderProps) => {
  const { t } = useTranslation()
  const { windowWidth } = useDeviceSize()
  const isPhoneBreakpoint = windowWidth <= deviceSize.phone

  const theme = useTheme()
  const headlineVariant = (
    theme.variant === ThemeVariants.DIGITAL
      ? 'business-title'
      : 'condensed-title'
  ) as TextTypesVariants

  return (
    <StyledHeader>
      <StyledHeaderContainer>
        <StyledBusinessHeaderWrapper headlineVariant={headlineVariant}>
          <StyledBusinessHeaderWrapperContent>
            {isPhoneBreakpoint ? (
              <>
                <StyledMobileImage>
                  <NativeImage
                    src={headerImage.headerImage}
                    srcSet={headerImage.headerImageSet}
                    width={'100%'}
                    alt={`Header Image`}
                  />
                </StyledMobileImage>
                <Text as={'h1'} variant={headlineVariant} html={t(headline)} />
              </>
            ) : (
              <Text as={'h1'} variant={headlineVariant} html={t(headline)} />
            )}
            <Text as={'p'} variant={'header-paragraph'}>
              {t(subheadline)}
            </Text>
            <Button variant={buttonVariant} href={'#contact'}>
              {t(buttonCta)}
            </Button>
          </StyledBusinessHeaderWrapperContent>
          {!isPhoneBreakpoint && (
            <StyledBusinessHeaderWrapperContent>
              <StyledImageContainer>
                <NativeImage
                  src={headerImage.headerImage}
                  srcSet={headerImage.headerImageSet}
                  width={'100%'}
                  alt={`Header Image`}
                />
              </StyledImageContainer>
            </StyledBusinessHeaderWrapperContent>
          )}
        </StyledBusinessHeaderWrapper>
      </StyledHeaderContainer>
    </StyledHeader>
  )
}

export default BusinessHeader
